import React, { useState, useEffect, useRef } from 'react';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
  Alert,
} from 'reactstrap';
import { toast } from 'react-toastify';
import ReactPlayer from 'react-player';
import { apiService } from '../../constants/ApiService';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../layouts/loader/Loader';
import ErrorModal from '../../constants/ErrorModal';
import SpinnerLoader from '../../constants/SpinnerLoader';
const API_URL = process.env.REACT_APP_API_BASE_URL;

const AddBranchMaster = () => {
  const [loading, setLoading] = useState(false);
  const [branchDetail, setBranchDetail] = useState({
    branch_name: '',
    branch_address: '',
    branch_city: null,
    branch_state: null,
    branch_country: 'India',
    branch_pin_code: '',
    branch_contact: '',
    branch_email: '',
    branch_website: '',
    branch_rating: null,
    branch_established_year: null,
    vender_master_id: null,

    branch_letter_head: '',
    branch_invoice_item_img: '',
    branch_invoice_temp: '',
    branch_sign_logo: '',
    qr_code: '',
    branch_location: '',
    branch_checkin: '',
    branch_checkout: '',
    branchImageMaster: [],
  });
  const [venderMasterTable, setVenderMasterTable] = useState([]);
  const [previewQrCodeImage, setPreviewQrCodeImage] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [stateTable, setStateTable] = useState([]);
  const [cityTable, setCityTable] = useState([]);
  const [multipleItemimages, setMultipleItemimages] = useState([]);
  const multipleImageRef = useRef(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewBranchLogoImage, setPreviewBranchLogoImage] = useState(null);
  const [previewBranchSignLogoImage, setPreviewBranchSignLogoImage] =
    useState(null);

  const onHandleBack = () => {
    navigate(-1);
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === 'branch_image') {
  //     const files = e.target.files;
  //     const imagesArray = [...multipleItemimages];

  //     // Check if the total number of files exceeds the limit
  //     if (imagesArray.length + files.length > 1) {
  //       alert('Maximum file upload is 1 files only');
  //       return;
  //     }

  //     const updatedImagesArray = [...imagesArray];

  //     // Loop through the files and read each one
  //     for (let i = 0; i < files.length; i++) {
  //       const reader = new FileReader();

  //       reader.onloadend = () => {
  //         const imageDataUrl = reader.result;
  //         updatedImagesArray.push(imageDataUrl);

  //         // Update state once all files are loaded
  //         if (updatedImagesArray.length === imagesArray.length + files.length) {
  //           setMultipleItemimages(updatedImagesArray);
  //         }
  //       };

  //       if (files[i]) {
  //         reader.readAsDataURL(files[i]);
  //       }
  //     }

  //     // Update the item data with new images
  //     const filesArray = Array.from(files);
  //     const updatedFilesArray = [
  //       ...branchDetail.branchImageMaster,
  //       ...filesArray,
  //     ];
  //     setBranchDetail((prevData) => ({
  //       ...prevData,
  //       branchImageMaster: updatedFilesArray,
  //     }));
  //   } else if (name === 'branch_hallmark_photo') {
  //     const files = e.target.files;

  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setPreviewImage(reader.result);
  //     };
  //     reader.readAsDataURL(files[0]);

  //     setBranchDetail((prevData) => ({
  //       ...prevData,
  //       [name]: files[0],
  //     }));
  //   } else if (name === 'branch_logo') {
  //     const files = e.target.files;

  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setPreviewBranchLogoImage(reader.result);
  //     };
  //     reader.readAsDataURL(files[0]);

  //     setBranchDetail((prevData) => ({
  //       ...prevData,
  //       [name]: files[0],
  //     }));
  //   } else if (name === 'branch_sign_logo') {
  //     const files = e.target.files;

  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setPreviewBranchSignLogoImage(reader.result);
  //     };
  //     reader.readAsDataURL(files[0]);

  //     setBranchDetail((prevData) => ({
  //       ...prevData,
  //       [name]: files[0],
  //     }));
  //   } else if (name === 'branch_state') {
  //     //console.log(value);

  //     let findData = stateTable.find((data) => data.state_Id === Number(value));

  //     //console.log(findData.state_Code, 'findDatafindData');

  //     setBranchDetail((prevCompany) => ({
  //       ...prevCompany,
  //       [name]: value,
  //       branch_state_code: findData.state_Code ? findData.state_Code : null,
  //       branch_city: '',
  //     }));
  //   } else {
  //     setBranchDetail((prevCompany) => ({
  //       ...prevCompany,
  //       [name]: value,
  //     }));
  //   }
  // };
  //heena
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'branch_image') {
      const selectedFiles = files;
      const imagesArray = [...multipleItemimages];

      if (!selectedFiles || selectedFiles.length === 0) return;

      // Check if the total number of files exceeds the limit
      if (imagesArray.length + selectedFiles.length > 1) {
        alert('Maximum file upload is 1 file only');
        return;
      }

      const updatedImagesArray = [...imagesArray];

      // Loop through the files and read each one
      for (let i = 0; i < selectedFiles.length; i++) {
        const reader = new FileReader();

        reader.onloadend = () => {
          const imageDataUrl = reader.result;
          updatedImagesArray.push(imageDataUrl);

          // Update state once all files are loaded
          if (
            updatedImagesArray.length ===
            imagesArray.length + selectedFiles.length
          ) {
            setMultipleItemimages(updatedImagesArray);
          }
        };

        if (selectedFiles[i]) {
          reader.readAsDataURL(selectedFiles[i]);
        }
      }

      // Update the item data with new images
      const filesArray = Array.from(selectedFiles);
      const updatedFilesArray = [
        ...(branchDetail.branchImageMaster || []),
        ...filesArray,
      ];

      setBranchDetail((prevData) => ({
        ...prevData,
        branchImageMaster: updatedFilesArray,
      }));
    } else if (name === 'branch_hallmark_photo') {
      if (!files || !files[0]) return;

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(files[0]);

      setBranchDetail((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else if (name === 'branch_logo') {
      if (!files || !files[0]) return;

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewBranchLogoImage(reader.result);
      };
      reader.readAsDataURL(files[0]);

      setBranchDetail((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else if (name === 'branch_sign_logo') {
      if (!files || !files[0]) return;

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewBranchSignLogoImage(reader.result);
      };
      reader.readAsDataURL(files[0]);

      setBranchDetail((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else if (name === 'qr_code') {
      if (!files || !files[0]) return;

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewQrCodeImage(reader.result);
      };
      reader.readAsDataURL(files[0]);

      setBranchDetail((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else if (name === 'branch_state') {
      const findData = stateTable.find(
        (data) => data.state_Id === Number(value),
      );

      setBranchDetail((prevCompany) => ({
        ...prevCompany,
        [name]: value,
        branch_state_code: findData?.state_Code ? findData.state_Code : null,
        branch_city: '',
      }));
    } else {
      setBranchDetail((prevCompany) => ({
        ...prevCompany,
        [name]: value,
      }));
    }
  };
  const removeImage = (indexToRemove) => {
    const updatedImages = multipleItemimages.filter(
      (image, index) => index !== indexToRemove,
    );
    setMultipleItemimages(updatedImages);

    const updatedFilesArray = branchDetail.branchImageMaster.filter(
      (file, index) => index !== indexToRemove,
    );

    const removedFile = branchDetail.branchImageMaster[indexToRemove]; // Get the removed file

    setBranchDetail((prevData) => ({
      ...prevData,
      branchImageMaster: updatedFilesArray,
      branchImageRemove: [...(prevData.branchImageRemove || []), removedFile], // Add to roomImageRemove
    }));
  };

  // get company list
  const getCompanyMasterData = async (page = 1, limit = 10, search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        // setVenderMasterTable(response.venderMasterData)
        if (response.venderMasterData.length === 1) {
          setVenderMasterTable(response.venderMasterData);
          setBranchDetail((prevDetails) => ({
            ...prevDetails,
            vender_master_id: response.venderMasterData[0].id,
          }));
        } else {
          setVenderMasterTable(response.venderMasterData);
        }
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading((prev) => ({ ...prev, vender: false }));
    }
  };

  // get state
  const getState = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/HelperMaster/allState`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setStateTable(response.state_Master);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  // get city
  const getCity = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/CityMaster/allCitys?page=1&limit=100000`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setCityTable(response.city_MasterDetailData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  // useEffect(() => {
  //     if (branchDetail?.branch_state) {
  //         getCity()
  //     }
  // }, [branchDetail?.branch_state])

  useEffect(() => {
    getCompanyMasterData();
    getState();
    getCity();
  }, [!venderMasterTable]);

  // async function uploadImagesFromArrayWithIndex(obj) {
  //   if (obj?.branchImageMaster?.length != 0 && obj.branchImageMaster) {
  //     for (let i = 0; i < obj.branchImageMaster.length; i++) {
  //       const newobj = obj.branchImageMaster[i];
  //       try {
  //         const imageUrl = await uploadImage(newobj);
  //         obj.branchImageMaster[i] = { branch_image: imageUrl };
  //       } catch (error) {
  //         console.error(`Error uploading image for index ${i}:`, error);
  //       }
  //     }
  //   }

  //   if (
  //     obj.branch_hallmark_photo &&
  //     typeof obj.branch_hallmark_photo === 'object' &&
  //     obj.branch_hallmark_photo !== null &&
  //     'name' in obj.branch_hallmark_photo
  //   ) {
  //     try {
  //       const imageUrl = await uploadImage(obj.branch_hallmark_photo);
  //       obj.branch_hallmark_photo = imageUrl;
  //     } catch (error) {
  //       console.error(`Error uploading image`, error);
  //     }
  //   }

  //   if (
  //     obj.branch_logo &&
  //     typeof obj.branch_logo === 'object' &&
  //     obj.branch_logo !== null &&
  //     'name' in obj.branch_logo
  //   ) {
  //     try {
  //       const imageUrl = await uploadImage(obj.branch_logo);
  //       obj.branch_logo = imageUrl;
  //     } catch (error) {
  //       console.error(`Error uploading image`, error);
  //     }
  //   }

  //   if (
  //     obj.branch_sign_logo &&
  //     typeof obj.branch_sign_logo === 'object' &&
  //     obj.branch_sign_logo !== null &&
  //     'name' in obj.branch_sign_logo
  //   ) {
  //     try {
  //       const imageUrl = await uploadImage(obj.branch_sign_logo);
  //       obj.branch_sign_logo = imageUrl;
  //     } catch (error) {
  //       console.error(`Error uploading image`, error);
  //     }
  //   }
  // }
  //heena
  async function uploadImagesFromArrayWithIndex(obj) {
    if (obj?.branchImageMaster?.length !== 0 && obj.branchImageMaster) {
      for (let i = 0; i < obj.branchImageMaster.length; i++) {
        const newobj = obj.branchImageMaster[i];
        try {
          const imageUrl = await uploadImage(newobj);
          obj.branchImageMaster[i] = { branch_image: imageUrl };
        } catch (error) {
          console.error(`Error uploading image for index ${i}:`, error);
        }
      }
    }

    if (
      obj.branch_hallmark_photo &&
      typeof obj.branch_hallmark_photo === 'object' &&
      obj.branch_hallmark_photo !== null &&
      'name' in obj.branch_hallmark_photo
    ) {
      try {
        const imageUrl = await uploadImage(obj.branch_hallmark_photo);
        obj.branch_hallmark_photo = imageUrl;
      } catch (error) {
        console.error('Error uploading branch_hallmark_photo:', error);
      }
    }

    if (
      obj.branch_logo &&
      typeof obj.branch_logo === 'object' &&
      obj.branch_logo !== null &&
      'name' in obj.branch_logo
    ) {
      try {
        const imageUrl = await uploadImage(obj.branch_logo);
        obj.branch_logo = imageUrl;
      } catch (error) {
        console.error('Error uploading branch_logo:', error);
      }
    }

    if (
      obj.branch_sign_logo &&
      typeof obj.branch_sign_logo === 'object' &&
      obj.branch_sign_logo !== null &&
      'name' in obj.branch_sign_logo
    ) {
      try {
        const imageUrl = await uploadImage(obj.branch_sign_logo);
        obj.branch_sign_logo = imageUrl;
      } catch (error) {
        console.error('Error uploading branch_sign_logo:', error);
      }
    }

    if (
      obj.qr_code &&
      typeof obj.qr_code === 'object' &&
      obj.qr_code !== null &&
      'name' in obj.qr_code
    ) {
      try {
        const imageUrl = await uploadImage(obj.qr_code);
        obj.qr_code = imageUrl;
      } catch (error) {
        console.error('Error uploading qr_code:', error);
      }
    }
  }
  async function uploadImage(image) {
    const uploadData = new FormData();
    uploadData.append('signature', image);

    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        accept: 'application/json',
      },
    };

    try {
      const response = await apiService.post(
        'api/BranchMaster/uploadfile',
        uploadData,
        config,
      );
      if (response.status === true) {
        return response.data;
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      throw new Error('Failed to upload image: ' + error.message);
    }
  }

  const [errors, setErrors] = useState({});
  const validateBranchForm = () => {
    const errors = {};

    if (!branchDetail.vender_master_id) {
      errors.vender_master_id = 'Vender name is required.';
    }

    // Validate hotel name
    if (!branchDetail.branch_name.trim()) {
      errors.branch_name = 'Branch name is required.';
    }

    // Validate hotel address
    if (!branchDetail.branch_address.trim()) {
      errors.branch_address = 'Branch address is required.';
    }

    // Validate hotel city
    if (!branchDetail.branch_city) {
      errors.branch_city = 'City is required.';
    }

    // Validate hotel state
    if (!branchDetail.branch_state) {
      errors.branch_state = 'State is required.';
    }

    // Validate hotel country
    if (!branchDetail.branch_country.trim()) {
      errors.branch_country = 'Country is required.';
    }

    // Validate hotel pin code (must be a 6-digit number)
    if (
      !branchDetail.branch_pin_code ||
      !/^\d{6}$/.test(branchDetail.branch_pin_code)
    ) {
      errors.branch_pin_code = 'Enter a valid 6-digit pin code.';
    }

    // Validate hotel contact (must be a 10-digit number)
    if (
      !branchDetail.branch_contact ||
      !/^\d{10}$/.test(branchDetail.branch_contact)
    ) {
      errors.branch_contact = 'Enter a valid 10-digit contact number.';
    }

    // Validate email format
    if (!branchDetail.branch_email.trim()) {
      errors.branch_email = 'Email is required.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(branchDetail.branch_email)) {
      errors.branch_email = 'Enter a valid email address.';
    }

    if (branchDetail?.venderMaster?.working_bussinesss_mode === 'HOTEL') {
      // Validate Branch Hotel Checkin
      if (!branchDetail.branch_checkin) {
        errors.branch_checkin = 'Booking Checkin Time is required.';
      }

      // Validate Branch Hotel Checkout
      if (!branchDetail.branch_checkout) {
        errors.branch_checkout = 'Booking Checkout Time is required.';
      }
    }

    // Validate that checkout is after checkin
    // if (branchDetail.branch_checkin && branchDetail.branch_checkout) {
    //     const checkInTime = new Date(`1970-01-01T${branchDetail.branch_checkin}`);
    //     const checkOutTime = new Date(`1970-01-01T${branchDetail.branch_checkout}`);

    //     if (checkOutTime <= checkInTime) {
    //         errors.branch_checkout = "Checkout time must be later than check-in time.";
    //     }
    // }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // add hotel detail
  const handleSubmit = async () => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    let validation = validateBranchForm();
    if (!validation) {
      setShowErrorModal(true);
      setIsSubmitting(false);

      return;
    }

    await uploadImagesFromArrayWithIndex(branchDetail);

    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      setLoading(true);
      const response = await apiService.post(
        `api/BranchMaster/create`,
        branchDetail,
        config,
      );
      setLoading(false);

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        navigate('/branch');
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  const getBranchDetail = async (hotelId) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/BranchMaster/detailById?branchId=${hotelId}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setBranchDetail(response.branchMasterByID);

        if (
          response.branchMasterByID &&
          response.branchMasterByID.branchImageMaster
        ) {
          setMultipleItemimages(response.branchMasterByID.branchImageMaster);
        }
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const UpdateBranchDetail = async () => {
    if (isSubmitting) {
      // If already submitting, do nothing
      return;
    }

    setIsSubmitting(true);

    let validation = validateBranchForm();
    if (!validation) {
      setIsSubmitting(false);
      setShowErrorModal(true);
      return;
    }

    await uploadImagesFromArrayWithIndex(branchDetail);

    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      setLoading(true);
      const response = await apiService.put(
        `api/BranchMaster/update?branchId=${branchDetail.id}`,
        branchDetail,
        config,
      );
      setLoading(false);

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast(response.message);
        navigate('/branch');
        // setPortfolioData(initial)
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  useEffect(() => {
    if (location.state) {
      getBranchDetail(location.state.hotelId);
      setEditMode(true);
    }
  }, [location.state]);

  const goTODeleteModel = (id) => {
    const currentUrl = `${window.location.origin}`;
    const url = `${currentUrl}/commonDelete?itemId=${id}&flag=timber_branch`;
    window.open(url, '_blank');
    setTimeout(() => {
      window.close();
    }, 1000);
  };

  const [pageloading, setPageLoading] = useState({
    vender: true,
  });

  useEffect(() => {
    const allApisLoaded = Object.values(pageloading).every(
      (status) => status === false,
    );

    if (!allApisLoaded) return;

    const newErrors = {};

    if (!venderMasterTable || venderMasterTable.length === 0) {
      newErrors.vender_master_id = 'Vender is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setShowErrorModal(true);
    } else {
      setErrors({});
      setShowErrorModal(false);
    }
  }, [venderMasterTable, pageloading]);

  if (Object.values(pageloading).some((status) => status === true)) {
    return <SpinnerLoader />;
  }

  // const SectionHeading = ({ icon, title, color }) => (
  //     <Alert color={color} className="d-flex align-items-center py-2 px-3" style={{ margin: "16px", width: "97%" }}>
  //         <span className="mr-2" style={{ fontSize: "1.2rem" }}>{icon}</span>
  //         <h5 className="mb-0 fw-bold">{title}</h5>
  //     </Alert>
  // );
  const SectionHeading = ({ icon, title, color }) => (
    <div
      className={`alert alert-${color} d-flex align-items-center`}
      style={{
        padding: '10px 16px',
        margin: '0 auto 16px auto',
        width: '97%',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '5px',
        fontWeight: 'bold',
      }}
    >
      <span style={{ fontSize: '1.2rem', marginRight: '10px' }}>{icon}</span>
      <h5 style={{ margin: 0, fontWeight: 700 }}>{title}</h5>
    </div>
  );

  return (
    <Col lg='12'>
      <Card className='bg-white pd-10 card-box mb-30'>
        {/* <CardTitle tag="h5" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"> */}
        <CardTitle
          tag='h6'
          className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between sticky-top'
          style={{
            // top: 0,
            // zIndex: 1020,
            // backgroundColor: "#ededed",
            // margin: 0,
            // textAlign: "center"
            backgroundColor: 'white',
          }}
        >
          {editMode ? (
            <div className='d-flex align-items-center'>
              <i className='bi bi-bell mr-2'></i>
              Edit Branch
            </div>
          ) : (
            <div className='d-flex align-items-center'>
              <i className='bi bi-bell mr-2'></i>
              Add Branch
            </div>
          )}

          {/* <Button color="warning" size="bg" onClick={onHandleBack} className="ml-auto">
                        Back
                    </Button> */}

          {/* {editMode && (
                        <>
                            <td>
                                <Button color="danger" size="bg" className='ms-2' onClick={() => goTODeleteModel(branchDetail.id)}>
                                    Delete
                                </Button>

                            </td>
                        </>
                    )} */}

          {editMode ? (
            <>
              <Button
                color='danger'
                className='ml-auto mr-2'
                onClick={() => goTODeleteModel(branchDetail.id)}
              >
                <i className='bi bi-trash mr-2'></i>
                Delete
              </Button>
              <Button
                type='button'
                className='mr-2'
                color='success'
                disabled={isSubmitting}
                onClick={() => UpdateBranchDetail()}
              >
                <i className='bi bi-save mr-2'></i>
                {loading ? <Loader /> : 'Update'}
              </Button>
            </>
          ) : (
            <Button
              type='button'
              className='ml-auto mr-2'
              color='success'
              disabled={isSubmitting}
              onClick={() => handleSubmit()}
            >
              <i className='bi bi-save mr-2'></i>
              {loading ? <Loader /> : 'Save'}
            </Button>
          )}

          {/* {editMode ?
                        <Button type="button" color="primary" disabled={isSubmitting} onClick={UpdateBranchDetail}>
                            {loading ? <Loader /> : "Update"}
                        </Button>
                        : <Button type="button" color="primary" disabled={isSubmitting} onClick={handleSubmit}>
                            {loading ? <Loader /> : "Save"}
                        </Button>} */}

          <Button color='warning' onClick={onHandleBack} className=''>
            <i className='bi bi-arrow-left mr-2'></i>
            Back
          </Button>
        </CardTitle>
        <CardBody>
          <Form>
            <Row>
              {(venderMasterTable.length === 0 ||
                venderMasterTable.length > 1) && (
                <Col xl={12}>
                  <FormGroup>
                    <Label tag='h6' for='vender_master_id'>
                      Vendor Name
                    </Label>
                    <Input
                      type='select'
                      className='custom-select'
                      name='vender_master_id'
                      id='vender_master_id'
                      value={branchDetail.vender_master_id}
                      onChange={handleChange}
                    >
                      <option>Select Company</option>
                      {venderMasterTable.map((data) => (
                        <option value={data.id}>{data.vender_name}</option>
                      ))}
                    </Input>
                    {errors.vender_master_id && (
                      <p className='text-danger'>{errors.vender_master_id}</p>
                    )}
                  </FormGroup>
                </Col>
              )}

              <SectionHeading
                color='primary'
                icon='🏢'
                title='Branch Information'
              />
              <Col xl={12}>
                <FormGroup>
                  <Label tag='h6' for='branch_name'>
                    {' '}
                    Name
                  </Label>
                  <Input
                    type='text'
                    name='branch_name'
                    id='branch_name'
                    value={branchDetail.branch_name}
                    onChange={handleChange}
                  />
                  {errors.branch_name && (
                    <p className='text-danger'>{errors.branch_name}</p>
                  )}
                </FormGroup>
              </Col>
              <Col xl={6}>
                <FormGroup>
                  <Label tag='h6' for='branch_email'>
                    {' '}
                    Email
                  </Label>
                  <Input
                    type='email'
                    name='branch_email'
                    id='branch_email'
                    value={branchDetail.branch_email}
                    onChange={handleChange}
                  />
                  {errors.branch_email && (
                    <p className='text-danger'>{errors.branch_email}</p>
                  )}
                </FormGroup>
              </Col>

              <Col xl={6}>
                <FormGroup>
                  <Label tag='h6' for='branch_contact'>
                    {' '}
                    Contact
                  </Label>
                  <Input
                    type='number'
                    name='branch_contact'
                    id='branch_contact'
                    onInput={(e) => {
                      if (e.target.value.length > 10) {
                        e.target.value = e.target.value.slice(0, 10);
                      }
                    }}
                    value={branchDetail.branch_contact}
                    onChange={handleChange}
                  />
                  {errors.branch_contact && (
                    <p className='text-danger'>{errors.branch_contact}</p>
                  )}
                </FormGroup>
              </Col>
              <Col xl={12}>
                <FormGroup>
                  <Label tag='h6' for='branch_address'>
                    Address
                  </Label>
                  <Input
                    type='text'
                    name='branch_address'
                    id='branch_address'
                    value={branchDetail.branch_address}
                    onChange={handleChange}
                  />
                  {errors.branch_address && (
                    <p className='text-danger'>{errors.branch_address}</p>
                  )}
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_website'>
                    Website
                  </Label>
                  <Input
                    type='text'
                    name='branch_website'
                    id='branch_website'
                    value={branchDetail.branch_website}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_rating'>
                    Rating
                  </Label>
                  <Input
                    type='number'
                    name='branch_rating'
                    id='branch_rating'
                    value={branchDetail.branch_rating}
                    onChange={handleChange}
                    step='0.01'
                  />
                </FormGroup>
              </Col>
              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_established_year'>
                    Established Year
                  </Label>
                  <Input
                    type='number'
                    name='branch_established_year'
                    id='branch_established_year'
                    value={branchDetail.branch_established_year}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_location'>
                    Maps Location
                  </Label>
                  <Input
                    type='text'
                    name='branch_location'
                    id='branch_location'
                    value={branchDetail.branch_location}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <SectionHeading
                color='success'
                icon='🌍'
                title='Location Details'
              />

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_country'>
                    Country
                  </Label>
                  <Input
                    type='text'
                    name='branch_country'
                    id='branch_country'
                    value={branchDetail.branch_country}
                    onChange={handleChange}
                  />
                  {errors.branch_country && (
                    <p className='text-danger'>{errors.branch_country}</p>
                  )}
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_state'>
                    State
                  </Label>
                  <Input
                    type='select'
                    className='custom-select'
                    name='branch_state'
                    id='branch_state'
                    value={branchDetail.branch_state}
                    onChange={handleChange}
                  >
                    <option>Select State</option>
                    {stateTable.map((data) => (
                      <option value={data.state_Id}>{data.state_Name}</option>
                    ))}
                  </Input>
                  {errors.branch_state && (
                    <p className='text-danger'>{errors.branch_state}</p>
                  )}
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_city'>
                    City
                  </Label>
                  <Input
                    type='select'
                    className='custom-select'
                    name='branch_city'
                    id='branch_city'
                    value={branchDetail.branch_city}
                    onChange={handleChange}
                  >
                    <option>Select City</option>
                    {/* {
                                            cityTable.map((data) => (
                                                <option value={data.id}>{data.city_Name}</option>
                                            ))
                                        } */}
                    {/* {
                                            (() => {
                                                return cityTable
                                                    ?.filter(city => city.state_id === branchDetail.branch_state)
                                                    ?.map(data => (
                                                        <option key={data.id} value={data.id}>
                                                            {data.city_Name}
                                                        </option>
                                                    ));
                                            })()
                                        } */}
                    {cityTable
                      ?.filter(
                        (city) =>
                          city.state_id === Number(branchDetail.branch_state),
                      )
                      .map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.city_name}
                        </option>
                      ))}
                  </Input>
                  {errors.branch_city && (
                    <p className='text-danger'>{errors.branch_city}</p>
                  )}
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_pin_code'>
                    Pin Code
                  </Label>
                  <Input
                    type='text'
                    name='branch_pin_code'
                    id='branch_pin_code'
                    value={branchDetail.branch_pin_code}
                    onChange={handleChange}
                  />
                  {errors.branch_pin_code && (
                    <p className='text-danger'>{errors.branch_pin_code}</p>
                  )}
                </FormGroup>
              </Col>

              {branchDetail?.venderMaster?.working_bussinesss_mode ===
                'HOTEL' && (
                <Col xl={6}>
                  <FormGroup>
                    <Label tag='h6' for='branch_checkin'>
                      Booking Check-In Time
                    </Label>
                    <Input
                      type='time'
                      name='branch_checkin'
                      id='branch_checkin'
                      value={branchDetail.branch_checkin}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
              )}

              {branchDetail?.venderMaster?.working_bussinesss_mode ===
                'HOTEL' && (
                <Col xl={6}>
                  <FormGroup>
                    <Label tag='h6' for='branch_checkout'>
                      Booking Check-Out Time
                    </Label>
                    <Input
                      type='time'
                      name='branch_checkout'
                      id='branch_checkout'
                      value={branchDetail.branch_checkout}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
              )}

              <Col xl={6}>
                <FormGroup>
                  <Label tag='h6' for='branch_off_checkin_time'>
                    Open Time
                  </Label>
                  <Input
                    type='time'
                    name='branch_off_checkin_time'
                    id='branch_off_checkin_time'
                    value={branchDetail.branch_off_checkin_time}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={6}>
                <FormGroup>
                  <Label tag='h6' for='branch_off_checkout_time'>
                    Closed Time
                  </Label>
                  <Input
                    type='time'
                    name='branch_off_checkout_time'
                    id='branch_off_checkout_time'
                    value={branchDetail.branch_off_checkout_time}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <SectionHeading
                color='warning'
                icon='💳'
                title='Bank Details & Legal Information'
              />

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_bank_acc'>
                    Bank Account
                  </Label>
                  <Input
                    type='text'
                    name='branch_bank_acc'
                    id='branch_bank_acc'
                    value={branchDetail.branch_bank_acc}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_bank_name'>
                    Bank Name
                  </Label>
                  <Input
                    type='text'
                    name='branch_bank_name'
                    id='branch_bank_name'
                    value={branchDetail.branch_bank_name}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_bank_branch'>
                    Bank Branch
                  </Label>
                  <Input
                    type='text'
                    name='branch_bank_branch'
                    id='branch_bank_branch'
                    value={branchDetail.branch_bank_branch}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_bank_ifcs'>
                    IFSC Code
                  </Label>
                  <Input
                    type='text'
                    name='branch_bank_ifcs'
                    id='branch_bank_ifcs'
                    value={branchDetail.branch_bank_ifcs}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_bank_holder_name'>
                    Account Holder Name
                  </Label>
                  <Input
                    type='text'
                    name='branch_bank_holder_name'
                    id='branch_bank_holder_name'
                    value={branchDetail.branch_bank_holder_name}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_bank_swift_code'>
                    SWIFT Code
                  </Label>
                  <Input
                    type='text'
                    name='branch_bank_swift_code'
                    id='branch_bank_swift_code'
                    value={branchDetail.branch_bank_swift_code}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_msme_no'>
                    MSME Number
                  </Label>
                  <Input
                    type='text'
                    name='branch_msme_no'
                    id='branch_msme_no'
                    value={branchDetail.branch_msme_no}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_gstin_no'>
                    GSTIN Number
                  </Label>
                  <Input
                    type='text'
                    name='branch_gstin_no'
                    id='branch_gstin_no'
                    value={branchDetail.branch_gstin_no}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_pancard_no'>
                    PAN Card Number
                  </Label>
                  <Input
                    type='text'
                    name='branch_pancard_no'
                    id='branch_pancard_no'
                    value={branchDetail.branch_pancard_no}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={3}>
                <FormGroup>
                  <Label tag='h6' for='branch_state_code'>
                    State Code
                  </Label>
                  <Input
                    type='text'
                    name='branch_state_code'
                    id='branch_state_code'
                    value={branchDetail.branch_state_code}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
              <Col sm={3}>
                {true && (
                  <FormGroup
                    className='text-center border rounded p-2 bg-white'
                    style={{
                      height: 160,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <img
                      src={
                        previewQrCodeImage ||
                        (branchDetail?.qr_code
                          ? API_URL + branchDetail.qr_code
                          : null) ||
                        '/images/img_placeholder.png'
                      }
                      alt='QR Preview'
                      className='img-fluid rounded mb-2'
                      style={{
                        width: '100%',
                        height: '100%',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                        borderRadius: '0.25rem',
                        overflow: 'hidden',
                      }}
                    />

                    {(previewQrCodeImage || branchDetail.qr_code) && (
                      <div className='d-flex justify-content-center gap-2'>
                        <a
                          href={
                            previewQrCodeImage ||
                            (branchDetail?.qr_code
                              ? API_URL + branchDetail.qr_code
                              : '#')
                          }
                          target='_blank'
                          rel='noopener noreferrer'
                          className='btn btn-outline-secondary'
                          title='View Image'
                        >
                          <i className='bi bi-eye'></i>
                        </a>

                        <button
                          type='button'
                          className='btn btn-danger'
                          title='Remove Image'
                          onClick={() => {
                            setPreviewQrCodeImage(null);
                            setBranchDetail((prev) => ({
                              ...prev,
                              qr_code: null,
                            }));
                          }}
                        >
                          <i className='bi bi-x-lg'></i>
                        </button>
                      </div>
                    )}
                  </FormGroup>
                )}

                <FormGroup>
                  <Label tag='h6' for='qr_code'>
                    QR Code
                  </Label>
                  <Input
                    className='form-control custom-border'
                    type='file'
                    name='qr_code'
                    id='qr_code'
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
              <SectionHeading
                color='danger'
                icon='📜'
                title='Billing Information'
              />

              <Col xs={6}>
                <FormGroup>
                  <Label for='branch_invoice_temp'>
                    Invoice Template Code (Ask Developer)
                  </Label>
                  <Input
                    type='text'
                    name='branch_invoice_temp'
                    id='branch_invoice_temp'
                    value={branchDetail.branch_invoice_temp}
                    onChange={handleChange}
                  >
                    {/* <option value="">Select Invoice Format</option>
                                        <option value="invoice">Invoice Format 1</option>
                                        <option value="invoice2">Invoice Format 2</option>
                                        <option value="invoice3">Invoice Format 3</option>
                                        <option value="invoice4">Invoice Format 4</option>
                                        <option value="invoice5">Invoice Format 5</option>
                                        <option value="invoice5_landscape">Invoice Format 5 Landscape</option>
                                        <option value="invoice6">Invoice Format 6</option>
                                        <option value="invoice7">Invoice Format 7</option>
                                        <option value="invoice8">Invoice Format 8</option>
                                        <option value="invoice8_optical">Invoice Format 7 Optical</option> */}
                  </Input>
                </FormGroup>
              </Col>
              <Col xs={3}>
                <FormGroup>
                  <Label for='branch_letter_head'>
                    Letter head with image (Yes/no)
                  </Label>
                  <Input
                    type='select'
                    className='custom-select'
                    name='branch_letter_head'
                    id='branch_letter_head'
                    value={branchDetail.branch_letter_head}
                    onChange={handleChange}
                  >
                    <option value=''>Select</option>
                    <option value='yes'>Yes</option>
                    <option value='no'>No</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col xs={3}>
                <FormGroup>
                  <Label for='branch_invoice_item_img'>
                    Letter Item Name with image (Yes/no)
                  </Label>
                  <Input
                    type='select'
                    className='custom-select'
                    name='branch_invoice_item_img'
                    id='branch_invoice_item_img'
                    value={branchDetail.branch_invoice_item_img}
                    onChange={handleChange}
                  >
                    <option value=''>Select</option>
                    <option value='yes'>Yes</option>
                    <option value='no'>No</option>
                  </Input>
                </FormGroup>
              </Col>

              <Col xl={12}>
                <FormGroup>
                  <Label tag='h6' for='branch_heading_sub_detail'>
                    Heading Sub Detail
                  </Label>
                  <Input
                    type='text'
                    name='branch_heading_sub_detail'
                    id='branch_heading_sub_detail'
                    value={branchDetail.branch_heading_sub_detail}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col xl={12}>
                <FormGroup>
                  <Label tag='h6' for='branch_specialist'>
                    Branch Specialist
                  </Label>
                  <Input
                    type='text'
                    name='branch_specialist'
                    id='branch_specialist'
                    value={branchDetail.branch_specialist}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Row>
                {/* Hallmark Photo */}
                <Col sm={3}>
                  {/* previewImage || branchDetail.branch_hallmark_photo */}
                  {true && (
                    // <Col sm={3}>
                    <FormGroup
                      className='text-center border rounded p-2 bg-white'
                      style={{
                        height: 160,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                    >
                      <img
                        src={
                          previewImage ||
                          (branchDetail?.branch_hallmark_photo
                            ? API_URL + branchDetail.branch_hallmark_photo
                            : null) ||
                          '/images/img_placeholder.png'
                        }
                        alt='Hallmark'
                        className='img-fluid rounded mb-2'
                        style={{
                          width: '100%',
                          height: '100%',
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                          borderRadius: '0.25rem',
                          overflow: 'hidden',
                          // backgroundColor: "#f0f0f0",
                        }}
                      />
                      {(previewImage || branchDetail.branch_hallmark_photo) && (
                        <div className='d-flex justify-content-center gap-2'>
                          <a
                            href={
                              previewImage ||
                              API_URL + branchDetail.branch_hallmark_photo
                            }
                            target='_blank'
                            rel='noopener noreferrer'
                            className='btn btn-outline-secondary'
                            title='View Image'
                          >
                            <i className='bi bi-eye'></i>
                          </a>
                          <button
                            type='button'
                            className='btn btn-danger'
                            onClick={() => {
                              setPreviewImage(null);
                              setBranchDetail((prev) => ({
                                ...prev,
                                branch_hallmark_photo: null,
                              }));
                            }}
                            title='Remove Image'
                          >
                            <i className='bi bi-x-lg'></i>
                          </button>
                        </div>
                      )}
                    </FormGroup>
                    // </Col>
                  )}
                  <FormGroup>
                    <Label tag='h6' for='branch_hallmark_photo'>
                      Hallmark Photo
                    </Label>
                    <Input
                      type='file'
                      name='branch_hallmark_photo'
                      id='branch_hallmark_photo'
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>

                {/* Branch Logo */}
                <Col sm={3}>
                  {true && (
                    <FormGroup
                      className='text-center border rounded p-2 bg-white'
                      style={{
                        height: 160,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                    >
                      <img
                        // src={previewBranchLogoImage || API_URL + branchDetail.branch_logo}
                        src={
                          previewBranchLogoImage ||
                          (branchDetail?.branch_logo
                            ? API_URL + branchDetail.branch_logo
                            : null) ||
                          '/images/img_placeholder.png'
                        }
                        alt='Logo'
                        className='img-fluid rounded mb-2'
                        style={{
                          width: '100%',
                          height: '100%',
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                          borderRadius: '0.25rem',
                          overflow: 'hidden',
                        }}
                      />
                      {previewBranchLogoImage ||
                        (branchDetail.branch_logo && (
                          <div className='d-flex justify-content-center gap-2'>
                            <a
                              href={
                                previewBranchLogoImage ||
                                API_URL + branchDetail.branch_logo
                              }
                              target='_blank'
                              rel='noopener noreferrer'
                              className='btn btn-outline-secondary'
                              title='View Image'
                            >
                              <i className='bi bi-eye'></i>
                            </a>
                            <button
                              type='button'
                              className='btn btn-danger'
                              onClick={() => {
                                setPreviewBranchLogoImage(null);
                                setBranchDetail((prev) => ({
                                  ...prev,
                                  branch_logo: null,
                                }));
                              }}
                              title='Remove Image'
                            >
                              <i className='bi bi-x-lg'></i>
                            </button>
                          </div>
                        ))}
                    </FormGroup>
                  )}
                  <FormGroup>
                    <Label tag='h6' for='branch_logo'>
                      Branch Logo
                    </Label>
                    <Input
                      type='file'
                      name='branch_logo'
                      id='branch_logo'
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>

                {/* <Col xl={3}>
                                    <FormGroup>
                                        <Label tag="h6" for="branch_sign_logo">Branch Sign Photo</Label>
                                        <Input
                                            
                                            type="file"
                                            name="branch_sign_logo"
                                            id="branch_sign_logo"
                                            // value={branchDetail.branch_sign_logo}
                                            onChange={handleChange}
                                        />
                                    </FormGroup>
                                </Col>
                                {(previewBranchSignLogoImage || branchDetail.branch_sign_logo) && <Col>
                                    <FormGroup>
                                        <img src={previewBranchSignLogoImage ? previewBranchSignLogoImage : API_URL + branchDetail.branch_sign_logo} alt="NO Image" style={{ width: 100 }} />
                                    </FormGroup>
                                </Col>} */}

                <Col sm={3}>
                  {true && (
                    <FormGroup
                      className='text-center border rounded p-2 bg-white'
                      style={{
                        height: 160,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                    >
                      <img
                        // src={previewBranchSignLogoImage || API_URL + branchDetail.branch_sign_logo}
                        src={
                          previewBranchSignLogoImage ||
                          (branchDetail?.branch_sign_logo
                            ? API_URL + branchDetail.branch_sign_logo
                            : null) ||
                          '/images/img_placeholder.png'
                        }
                        alt='No Preview'
                        className='img-fluid rounded mb-2'
                        style={{
                          width: '100%',
                          height: '100%',
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                          borderRadius: '0.25rem',
                          overflow: 'hidden',
                        }}
                      />

                      {/* Action buttons */}
                      {(previewBranchSignLogoImage ||
                        branchDetail.branch_sign_logo) && (
                        <div className='d-flex justify-content-center gap-2'>
                          <a
                            href={
                              previewBranchSignLogoImage ||
                              API_URL + branchDetail.branch_sign_logo
                            }
                            target='_blank'
                            rel='noopener noreferrer'
                            className='btn btn-outline-secondary'
                            title='View Image'
                          >
                            <i className='bi bi-eye'></i>
                          </a>

                          <button
                            type='button'
                            className='btn btn-danger'
                            title='Remove Image'
                            onClick={() => {
                              setPreviewBranchSignLogoImage(null);
                              setBranchDetail((prev) => ({
                                ...prev,
                                branch_sign_logo: null,
                              }));
                            }}
                          >
                            <i className='bi bi-x-lg'></i>
                          </button>
                        </div>
                      )}
                    </FormGroup>
                  )}
                  <FormGroup>
                    <Label tag='h6' for='branch_sign_logo'>
                      Branch Sign Photo
                    </Label>
                    <Input
                      className='form-control custom-border'
                      type='file'
                      name='branch_sign_logo'
                      id='branch_sign_logo'
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>

              {/* <Row>



                                <Col xl={3}>
                                    <FormGroup>
                                        <Label tag="h6" for="branch_image"> Letter Head Image</Label>
                                        <Input 
                                            type="file"
                                            name="branch_image"
                                            id="branch_image"
                                            value={branchDetail.branch_image}
                                            onChange={handleChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xl={12}>
                                    {multipleItemimages.map((image, index) => {
                                        const imageUrl = typeof image === 'string'
                                            ? image
                                            : typeof image.branch_image === 'string'
                                                ? API_URL + image.branch_image
                                                : null;

                                        return (
                                            <div
                                                key={index}
                                                style={{
                                                    position: 'relative',
                                                    display: 'inline-flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    margin: '5px',
                                                    width: '120px',
                                                    height: '120px',
                                                    flexDirection: 'column',
                                                    borderRadius: '5px',
                                                    boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                {imageUrl?.startsWith('data:image/') ||
                                                    (imageUrl?.endsWith('.jpg') ||
                                                        imageUrl?.endsWith('.jpeg') ||
                                                        imageUrl?.endsWith('.png') ||
                                                        imageUrl?.endsWith('.gif') ||
                                                        imageUrl?.endsWith('.webp')
                                                    ) ? (
                                                    <img
                                                        src={imageUrl}
                                                        alt={`Uploaded Image ${index + 1}`}
                                                        style={{
                                                            maxWidth: '120px',
                                                            maxHeight: '120px',
                                                            margin: '2px',
                                                            borderRadius: '5px',
                                                            boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
                                                        }}
                                                    />
                                                ) : imageUrl?.startsWith('data:video/') ||
                                                    (imageUrl?.endsWith('.mp4') ||
                                                        imageUrl?.endsWith('.avi') ||
                                                        imageUrl?.endsWith('.mov') ||
                                                        imageUrl?.endsWith('.mkv')) ? (
                                                    <ReactPlayer
                                                        url={imageUrl}
                                                        controls={true}
                                                        width="120px"
                                                        height="120px"
                                                        style={{
                                                            borderRadius: '5px',
                                                            boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
                                                        }}
                                                    />
                                                ) : (
                                                    <p style={{ color: 'red' }}>Unsupported file type</p>
                                                )}

                                                <button
                                                    type="button"
                                                    onClick={() => removeImage(index)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '5px',
                                                        right: '5px',
                                                        background: '#de1313',
                                                        border: 'none',
                                                        borderRadius: '10%',
                                                        padding: '5px',
                                                        cursor: 'pointer',
                                                        fontSize: '20px',
                                                        color: 'rgb(243 243 243)',
                                                    }}
                                                >
                                                    &times;
                                                </button>
                                            </div>


                                        );
                                    })}
                                </Col>
                            </Row> */}
              <Row>
                <Col sm={12} className='mt-2'>
                  <div
                    className='d-flex flex-wrap border rounded'
                    style={{ height: '200px' }}
                  >
                    {multipleItemimages.map((image, index) => {
                      const imageUrl =
                        typeof image === 'string'
                          ? image
                          : typeof image.branch_image === 'string'
                            ? API_URL + image.branch_image
                            : null;

                      const isImage =
                        imageUrl &&
                        (imageUrl.startsWith('data:image/') ||
                          imageUrl.match(/\.(jpg|jpeg|png|gif|webp)$/i));

                      const isVideo =
                        imageUrl &&
                        (imageUrl.startsWith('data:video/') ||
                          imageUrl.match(/\.(mp4|avi|mov|mkv)$/i));

                      return (
                        <div sm={3}>
                          <div
                            key={index}
                            className='position-relative m-2 border rounded shadow-sm p-2 d-flex flex-column align-items-center'
                            // style={{ height: '200px', backgroundColor: '#ffffffff' }}
                          >
                            {isImage ? (
                              <img
                                src={imageUrl}
                                alt={`Uploaded Image ${index + 1}`}
                                className='img-fluid mb-1 rounded'
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  maxWidth: '100%',
                                  maxHeight: '100%',
                                  objectFit: 'contain',
                                  borderRadius: '0.25rem',
                                  overflow: 'hidden',
                                }}
                              />
                            ) : isVideo ? (
                              <ReactPlayer
                                url={imageUrl}
                                controls
                                width='100px'
                                height='100px'
                                style={{ borderRadius: '5px' }}
                              />
                            ) : (
                              <p className='text-danger small'>
                                Unsupported file
                              </p>
                            )}

                            <div className='d-flex justify-content-center gap-2'>
                              {imageUrl && (
                                <a
                                  href={imageUrl}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  className='btn btn-outline-secondary btn-sm'
                                  title='View'
                                >
                                  <i className='bi bi-eye'></i>
                                </a>
                              )}
                              <button
                                type='button'
                                className='btn btn-danger btn-sm'
                                onClick={() => removeImage(index)}
                                title='Remove'
                              >
                                <i className='bi bi-x-lg'></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Col>
                <Col sm={3}>
                  <FormGroup>
                    <Label tag='h6' for='branch_image'>
                      Letter Head Image
                    </Label>
                    <Input
                      type='file'
                      name='branch_image'
                      id='branch_image'
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Col xl={8}>
                {/* {editMode ?
                                    <Button type="button" color="primary" disabled={isSubmitting} onClick={UpdateBranchDetail}>
                                        {loading ? <Loader /> : "Update"}
                                    </Button>
                                    : <Button type="button" color="primary" disabled={isSubmitting} onClick={handleSubmit}>
                                        {loading ? <Loader /> : "Save"}
                                    </Button>} */}
              </Col>
            </Row>
          </Form>
        </CardBody>

        {/* Error Model */}

        <ErrorModal
          show={showErrorModal}
          title='Validation / Action Required'
          content={errors}
          condition={true}
          onCancel={() => setShowErrorModal(false)}
          // onConfirm={true}
        />
      </Card>
    </Col>
  );
};

export default AddBranchMaster;
